import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#d22630",
        secondary: "#003895",
        accent: "#07C730",
        error: "#5E4EF6",
        info: "#FF6C00",
        success: "#991CD3",
        warning: "#2BA681",
        yel: "#FFEA00",
        roodt: "#D01F40",
        spec: "#003895",
        leftPanel: "#F2F2F2",
      },
      dark: {
        primary: "#d22630",
        secondary: "#003895",
        accent: "#07C730",
        error: "#5E4EF6",
        info: "#FF6C00",
        success: "#991CD3",
        warning: "#2BA681",
        yel: "#FFEA00",
        roodt: "#D01F40",
        spec: "#FFEA00",
        leftPanel: "#607D8B",
      },
    },
  },
});
